import { Component, OnInit, Input } from '@angular/core';
import { CpMarketplaceApiService } from '../services/cp-marketplace-api.service';
import { SharedDataService } from '../services/shared-data.service';
import { RUPEE_CODE } from './global-meta-data';

@Component({
  selector: 'app-issue-completion-bar',
  template: `
    <div *ngIf='showText && valueCompleted'>
      {{issue?.issue_completion_percentage | number:'1.0-2' }}% Done :
      {{ valueCompleted.toString()  | SmartValuePipe: rupeeCode}}
    </div>
    <div *ngIf='showText && !valueCompleted'>
      {{issue?.issue_completion_percentage | number:'1.0-2' }}% Done
    </div>
    <ngb-progressbar type="info" [value]="issue?.issue_completion_percentage"></ngb-progressbar>
  `,
  styles: []
})

export class CompletionBarComponent implements OnInit {

  @Input() issue;
  @Input() showText = false;
  valueCompleted = 0;
  rupeeCode = RUPEE_CODE;

  constructor(
    private apiService: CpMarketplaceApiService,
    private data: SharedDataService
  ) { }

  ngOnInit() {
    if (this.issue && this.issue.issue_completion_percentage) {
      this.valueCompleted = (this.issue.issue_completion_percentage / 100) * this.issue.issue_cap;
    }
  }
}
